function serviceDateTimeToIso(dateTime) {
  // We've got date time strings from the service in a format of '2020-09-09 12:00:00'
  // For all browsers support, we have to standardize them to ISO 8601: '2020-09-09T12:00:00Z'
  const dateTimeIso = typeof dateTime === 'string' ? `${dateTime.split(' ').join('T')}Z` : dateTime;
  return dateTimeIso;
}

export default serviceDateTimeToIso;
